import { User } from './../user-details-forum/user-details-forum.component';
import { BadgeServiceService } from './../services/badgeService/badge-service.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {

  users: User[] = [];
  currentUser:User = {
    employerName: '',
    county: 'Please enter address',
    address: '',
    email: '',
    paName: '',
    image: '',
    id: 0
  }
  hideText: boolean = false;
  hidePaText: boolean = false;

  constructor(private _badgeService:BadgeServiceService, private _router: Router) {
    this._badgeService.usersObservable.subscribe((value) => {
      this.users = value;
    });
  }

  ngOnInit(): void {
    this.users = this._badgeService.users;
    this.setWindow();
  }

  getBasketTotal(): number {
    var price = 0;
    this.users.forEach((user) => {
      price += 0;
    });
    return price;
  }

  deleteUser(): void {
    var result = confirm("Are you sure you want to delete?");
    if (!result) { return; }
    var find = this._badgeService.users.findIndex(x => x.paName == this.currentUser.paName);
    this._badgeService.users.splice(find);
    this._badgeService.usersObservable.next(this._badgeService.users);
  }

  redirectToHome(): void {
    this._router.navigate(["/user-details-forum"]);
    this._badgeService.selectedUser = {
      employerName: '',
      county: 'Please enter address',
      address: '',
      email: '',
      paName: '',
      image: '',
      id: 0
    };
    this._badgeService.editUser = false;
    this._badgeService.editUserObservable.next(this._badgeService.selectedUser);
  }

  editUser(): void {
    this._router.navigate(["/user-details-forum"]);
    this._badgeService.selectedUser = this.currentUser;
    this._badgeService.editUser = true;
    this._badgeService.editUserObservable.next(this._badgeService.selectedUser);
  }

  onResize(): void {
    this.setWindow();
  }

  setWindow(): void {
    if (window.innerWidth <= 1200) {
      this.hideText = true;
    } else {
      this.hideText = false;
    }
    if (window.innerWidth <=970) {
      this.hidePaText = true;
    } else {
      this.hidePaText = false;
    }
  }

  checkout(): void {
    this._router.navigate(["/checkout-form"]);
  }

}
